export const PRODUCTS = [

  

  // ============================================================
  // PORCELAIN 12x24
  // ============================================================
  {
    id: "POR-001",
    collection: "rocagres",
    slug: "alto-grey-12x24",
    name: "Alto Grey",
    category: "porcelain",
    finish: "Matte / Glossy",
    sizes: ["12x24"],
    priceRange: "$3\u2013$5/sq ft",
    inStock: true,
    colors: ["grey"],
    featured: true,
    description: "Alto Grey is a sleek matte-finish porcelain with a cool mid-grey tone, ideal for modern interiors. Its smooth surface and clean lines create a refined backdrop for both residential and commercial spaces. Available in the versatile 12x24 format for floors and walls.",
    images: [{ url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t7.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/alto-grey/alto-grey-t8.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#8a8f95",
      groutColor: "#7a7f85",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 60,
      tileHeight: 120,
      veins: [],
    },
  },
  {
    id: "POR-002",
    collection: "rocagres",
    slug: "calacata-gold-12x24",
    name: "Calacata Gold",
    category: "porcelain",
    finish: "Matte / Glossy",
    sizes: ["12x24"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["white", "gold"],
    featured: true,
    description: "Calacata Gold porcelain replicates the prestigious Italian marble with striking gold veining on a brilliant white ground. This polished porcelain delivers the luxury look of natural marble at a fraction of the cost. Perfect for feature walls, bathroom surrounds, and upscale flooring.",
    images: [{ url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/calacata-gold/calacata-gold-p6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f2ece2",
      groutColor: "#d8d2c8",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 60,
      tileHeight: 120,
      veins: ["M 10 20 Q 40 60 55 120", "M 30 10 Q 50 80 60 120"],
    },
  },
  {
    id: "POR-003",
    collection: "rocagres",
    slug: "flexo-tech-bianco-12x24",
    name: "Flexo Tech Bianco",
    category: "porcelain",
    finish: "Matte",
    sizes: ["12x24"],
    priceRange: "$3\u2013$5/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "Flexo Tech Bianco is a crisp white matte porcelain with a subtle textured surface, inspired by contemporary concrete aesthetics. Its neutral tone pairs effortlessly with any design palette, making it a go-to choice for minimalist spaces.",
    images: [{ url: "/assets/images/tiles/12x24/flexo-tech-bianco/flexo-tech-bianco-003-dp-matt-008-h-p1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/12x24/flexo-tech-bianco/flexo-tech-bianco-003-dp-matt-008-h-p2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/flexo-tech-bianco/flexo-tech-bianco-003-dp-matt-008-h-p3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/flexo-tech-bianco/flexo-tech-bianco-003-dp-matt-008-h-p4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f0eeea",
      groutColor: "#dcdad6",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 60,
      tileHeight: 120,
      veins: [],
    },
  },
  {
    id: "POR-004",
    collection: "rocagres",
    slug: "flexo-tech-natural-12x24",
    name: "Flexo Tech Natural",
    category: "porcelain",
    finish: "Matte / Glossy",
    sizes: ["12x24"],
    priceRange: "$3\u2013$5/sq ft",
    inStock: true,
    colors: ["beige"],
    featured: false,
    description: "Flexo Tech Natural features a warm beige tone with a lightly textured matte surface that evokes natural stone. Its understated elegance suits contemporary, transitional, and rustic interiors alike.",
    images: [{ url: "/assets/images/tiles/12x24/flexo-tech-natural/flexo-tech-natural-003-dp-matt-6-1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/12x24/flexo-tech-natural/flexo-tech-natural-003-dp-matt-6-2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/flexo-tech-natural/flexo-tech-natural-003-dp-matt-6-3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/flexo-tech-natural/flexo-tech-natural-003-dp-matt-6-4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#d8cfc0",
      groutColor: "#c0b8ac",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 60,
      tileHeight: 120,
      veins: [],
    },
  },
  {
    id: "POR-005",
    collection: "rocagres",
    slug: "rockland-ivory-12x24",
    name: "Rockland Ivory",
    category: "porcelain",
    finish: "Matte / Glossy",
    sizes: ["12x24"],
    priceRange: "$3\u2013$5/sq ft",
    inStock: true,
    colors: ["ivory", "beige"],
    featured: false,
    description: "Rockland Ivory is a warm ivory porcelain with a carved-stone texture finish that adds depth and character. The subtle surface variation mimics natural limestone, bringing warmth and organic beauty to any space.",
    images: [{ url: "/assets/images/tiles/12x24/rockland-ivory/rockland-ivory-006-dp-matt-carvin-punch-04-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/12x24/rockland-ivory/rockland-ivory-006-dp-matt-carvin-punch-04-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/rockland-ivory/rockland-ivory-006-dp-matt-carvin-punch-04-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/12x24/rockland-ivory/rockland-ivory-006-dp-matt-carvin-punch-04-f4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#e8e0d0",
      groutColor: "#d0c8b8",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 60,
      tileHeight: 120,
      veins: [],
    },
  },

  // ============================================================
  // PORCELAIN 24x48
  // ============================================================
  {
    id: "POR-006",
    collection: "rocagres",
    slug: "cafe-end-24x48",
    name: "Caf\u00e9 End",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["beige", "grey"],
    featured: false,
    description: "Caf\u00e9 End features warm taupe and beige tones with a subtle concrete-inspired matte finish. This large-format tile brings a sophisticated, caf\u00e9-culture aesthetic to living rooms, kitchens, and commercial spaces.",
    images: [{ url: "/assets/images/tiles/24x48/5153-cafe-end/5153-cafe-end-p1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/5153-cafe-end/5153-cafe-end-p2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/5153-cafe-end/5153-cafe-end-p3.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#b8a898",
      groutColor: "#a89888",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-007",
    collection: "rocagres",
    slug: "camio-grey-24x48",
    name: "Camio Grey",
    category: "porcelain",
    finish: "Matte Carving",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["grey"],
    featured: false,
    description: "Camio Grey is a sophisticated large-format porcelain with a rich mid-grey tone and natural stone movement. Its matte surface provides excellent grip while maintaining an upscale appearance, making it ideal for high-traffic areas.",
    images: [{ url: "/assets/images/tiles/24x48/camio-grey/end-612-171n-g4-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/camio-grey/end-612-171n-g4-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/camio-grey/end-612-171n-g4-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/camio-grey/end-612-171n-g4-f4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#7a8088",
      groutColor: "#6a7078",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-008",
    collection: "rocagres",
    slug: "camio-nero-24x48",
    name: "Camio Nero",
    category: "porcelain",
    finish: "Matte Carving",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["black"],
    featured: false,
    description: "Camio Nero delivers dramatic depth with its deep charcoal-black matte finish. This large-format porcelain creates bold, architectural statements in contemporary interiors, whether used on floors or as dramatic feature walls.",
    images: [{ url: "/assets/images/tiles/24x48/camio-nero/end-612-171n-g1-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/camio-nero/end-612-171n-g1-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/camio-nero/end-612-171n-g1-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/camio-nero/end-612-171n-g1-f4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#282828",
      groutColor: "#1a1a1a",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-009",
    collection: "rocagres",
    slug: "desert-verde-24x48",
    name: "Desert Verde",
    category: "porcelain",
    finish: "Matte",
    sizes: ["24x48"],
    priceRange: "$5\u2013$9/sq ft",
    inStock: true,
    colors: ["green"],
    featured: false,
    description: "Desert Verde captures the rare beauty of green-toned natural stone with subtle earthy movement. This unique porcelain brings the tranquility of the natural world indoors, perfect for spa-inspired bathrooms and serene living spaces.",
    images: [{ url: "/assets/images/tiles/24x48/desert-verde-n-1018-1l/n-1018-1l.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/desert-verde-n-1018-1l/whatsapp-image-2025-08-04-at-16-47-17.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#8a9878",
      groutColor: "#7a8868",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-010",
    collection: "rocagres",
    slug: "end-flora-garnet-24x48",
    name: "Flora Garnet",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["brown"],
    featured: false,
    description: "Flora Garnet features a rich burgundy-garnet tone with natural stone-like movement and a refined matte finish. This striking porcelain adds warmth and drama to accent walls, foyers, and statement floors.",
    images: [{ url: "/assets/images/tiles/24x48/end-flora-garnet/end-flora-garnet-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-flora-garnet/end-flora-garnet-r2.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#8B3A4A",
      groutColor: "#7A2A3A",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-011",
    collection: "rocagres",
    slug: "ibiza-white-24x48",
    name: "Ibiza White",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["24x48"],
    priceRange: "$5\u2013$9/sq ft",
    inStock: true,
    colors: ["white"],
    featured: true,
    description: "Ibiza White is a pristine polished porcelain that radiates brightness and elegance. Its high-gloss surface reflects light beautifully, creating the illusion of space \u2014 ideal for smaller rooms, bathrooms, and open-plan living areas.",
    images: [{ url: "/assets/images/tiles/24x48/end-ibiza-white/end-ibiza-white-p1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-ibiza-white/end-ibiza-white-p2.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/end-ibiza-white.mp4",
    patternConfig: {
      baseColor: "#f5f3f0",
      groutColor: "#e0ddd8",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-012",
    collection: "rocagres",
    slug: "impressa-black-24x48",
    name: "Impressa Black",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["black"],
    featured: false,
    description: "Impressa Black is a high-gloss deep black porcelain that creates a bold, luxurious impact. Perfect for feature walls in kitchens and bathrooms, this tile adds dramatic sophistication and reflects light for a stunning effect.",
    images: [{ url: "/assets/images/tiles/24x48/end-impressa-black/end-impressa-black-p1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-impressa-black/end-impressa-black-p2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-impressa-black/end-impressa-black-p3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-impressa-black/end-impressa-black-p4.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/end-impressa-black.mp4",
    patternConfig: {
      baseColor: "#101010",
      groutColor: "#080808",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-013",
    collection: "rocagres",
    slug: "madrid-shine-24x48",
    name: "Madrid Shine",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$6\u2013$10/sq ft",
    inStock: true,
    colors: ["ivory", "white"],
    featured: false,
    description: "Madrid Shine captures the opulence of European marble design with its highly polished surface and rich veining pattern. This premium porcelain brings the grandeur of Mediterranean architecture to modern residential and hospitality projects.",
    images: [{ url: "/assets/images/tiles/24x48/end-madrid-shine/end-madrid-shine-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-madrid-shine/end-madrid-shine-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-madrid-shine/end-madrid-shine-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-madrid-shine/end-madrid-shine-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#e8e0d0",
      groutColor: "#d0c8b8",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: ["M 20 30 Q 80 100 120 240", "M 60 0 Q 100 80 110 200"],
    },
  },
  {
    id: "POR-014",
    collection: "rocagres",
    slug: "madrid-silver-24x48",
    name: "Madrid Silver",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$6\u2013$10/sq ft",
    inStock: true,
    colors: ["grey", "silver"],
    featured: false,
    description: "Madrid Silver offers a cool silver-grey marble effect with elegant veining in a large-format polished finish. Its refined aesthetic suits luxury apartments, hotel lobbies, and contemporary commercial interiors.",
    images: [{ url: "/assets/images/tiles/24x48/end-madrid-silver/end-madrid-silver-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-madrid-silver/end-madrid-silver-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-madrid-silver/end-madrid-silver-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-madrid-silver/end-madrid-silver-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#c8cdd2",
      groutColor: "#b0b5ba",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: ["M 10 50 Q 60 120 120 180", "M 40 0 Q 90 100 120 240"],
    },
  },
  {
    id: "POR-015",
    collection: "rocagres",
    slug: "posco-teal-24x48",
    name: "Posco Teal",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["teal"],
    featured: false,
    description: "Posco Teal is a distinctive large-format porcelain with a captivating teal-green tone and natural stone movement. This bold, design-forward tile creates stunning focal points in kitchens, bathrooms, and hospitality spaces.",
    images: [{ url: "/assets/images/tiles/24x48/end-posco-teal/end-posco-teal-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-posco-teal/end-posco-teal-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-posco-teal/end-posco-teal-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-posco-teal/end-posco-teal-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#4a8a88",
      groutColor: "#3a7a78",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-016",
    collection: "rocagres",
    slug: "snowrock-24x48",
    name: "Snowrock",
    category: "porcelain",
    finish: "Matte / Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "Snowrock features a white-on-white stone texture with subtle movement and a sophisticated matte finish. This clean, modern porcelain is highly versatile \u2014 equally at home in minimalist bathrooms, open kitchens, and contemporary retail spaces.",
    images: [{ url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r7.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/end-snowrock/end-snowrock-r8.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/end-snowrock.mp4",
    patternConfig: {
      baseColor: "#f0eeec",
      groutColor: "#dcdad8",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-017",
    collection: "rocagres",
    slug: "himalaya-white-24x48",
    name: "Himalaya White",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["24x48"],
    priceRange: "$6\u2013$9/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "Himalaya White is an ultra-clean polished porcelain with a pristine white surface and faint crystalline movement. Inspired by high-altitude stone formations, this tile brings purity and light to any space.",
    images: [{ url: "/assets/images/tiles/24x48/himalaya-white/whatsapp-image-2025-08-04-at-16-47-18.jpg", alt: "", type: "primary" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f8f6f4",
      groutColor: "#e4e2e0",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-018",
    collection: "rocagres",
    slug: "lucid-black-24x48",
    name: "Lucid Black",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["black"],
    featured: false,
    description: "Lucid Black is a deep, mirror-polished porcelain that delivers unmatched drama and sophistication. Its flawless surface creates a high-end aesthetic for luxury bathrooms, statement kitchen splashbacks, and upscale commercial projects.",
    images: [{ url: "/assets/images/tiles/24x48/lucid-black/lucid-black-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/lucid-black/lucid-black-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/lucid-black/lucid-black-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/lucid-black/lucid-black-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#161616",
      groutColor: "#0c0c0c",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-019",
    collection: "rocagres",
    slug: "makenza-bianco-24x48",
    name: "Makenza Bianco",
    category: "porcelain",
    finish: "Matte",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["white", "ivory"],
    featured: true,
    description: "Makenza Bianco presents a beautiful white marble-effect porcelain with delicate grey veining and a premium matte finish. Its large-format design creates seamless, flowing surfaces that evoke the grandeur of natural Italian marble.",
    images: [{ url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-bianco/makenza-bianco-f6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f0ede8",
      groutColor: "#dcdad5",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: ["M 15 40 Q 70 100 120 200", "M 50 0 Q 90 120 100 240"],
    },
  },
  {
    id: "POR-020",
    collection: "rocagres",
    slug: "makenza-grey-24x48",
    name: "Makenza Grey",
    category: "porcelain",
    finish: "Matte",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["grey"],
    featured: false,
    description: "Makenza Grey is a sophisticated concrete-inspired porcelain with a warm grey tone and natural textural variation. This large-format tile creates a contemporary industrial aesthetic while maintaining the practicality of porcelain.",
    images: [{ url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/makenza-grey/makenza-grey-f6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#909490",
      groutColor: "#808480",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-021",
    collection: "rocagres",
    slug: "new-carara-24x48",
    name: "New Carara",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["24x48"],
    priceRange: "$5\u2013$9/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "New Carara is a premium marble-effect porcelain replicating the timeless beauty of Carrara marble with white base and soft grey veining. Its large-format polished surface creates a seamless, luxurious aesthetic.",
    images: [{ url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/new-carara/112-new-carara-f6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f2f0ec",
      groutColor: "#dedad6",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: ["M 10 30 Q 60 90 120 160", "M 40 0 Q 80 100 100 240"],
    },
  },
  {
    id: "POR-022",
    collection: "rocagres",
    slug: "rynestone-24x48",
    name: "Rynestone",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["beige"],
    featured: false,
    description: "Rynestone captures the rugged beauty of natural stone with a richly textured matte surface and warm earth tones. This porcelain is perfect for bringing an organic, grounded feel to contemporary and rustic-inspired interiors.",
    images: [{ url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/rynestone/40118-rynestone-f6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#c0b8a8",
      groutColor: "#b0a898",
      groutWidth: 5,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },
  {
    id: "POR-023",
    collection: "rocagres",
    slug: "viga-silver-24x48",
    name: "Viga Silver",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["24x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["grey", "silver"],
    featured: false,
    description: "Viga Silver features a cool silver-grey tone with subtle concrete-effect texture and a refined matte finish. This large-format porcelain is versatile enough for floors, walls, and exterior facades in modern architectural projects.",
    images: [{ url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/24x48/viga-silver/1930-viga-silver-f6.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#b0b4b8",
      groutColor: "#a0a4a8",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 120,
      tileHeight: 240,
      veins: [],
    },
  },

  // ============================================================
  // PORCELAIN 48x72 (Large Format)
  // ============================================================
  {
    id: "POR-024",
    collection: "rocagres",
    slug: "calacatta-averio-48x72",
    name: "Calacatta Averio",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["48x72"],
    priceRange: "$9\u2013$15/sq ft",
    inStock: false,
    colors: ["white", "gold"],
    featured: true,
    description: "Calacatta Averio is a breathtaking large-format porcelain slab with sweeping gold veining on a radiant white ground. This 48x72 format creates near-seamless surfaces of unrivalled elegance, perfect for grand bathrooms, feature walls, and luxury commercial flooring.",
    images: [{ url: "/assets/images/tiles/48x72/calacatta-averio/calacatta-averio-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/calacatta-averio/calacatta-averio-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calacatta-averio/calacatta-averio-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calacatta-averio/calacatta-averio-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#f4f0e8",
      groutColor: "#dedad0",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 20 40 Q 120 150 192 250", "M 80 0 Q 150 200 160 288"],
    },
  },
  {
    id: "POR-025",
    collection: "rocagres",
    slug: "calypso-grigio-48x72",
    name: "Calypso Grigio",
    category: "porcelain",
    finish: "Matte",
    sizes: ["48x72"],
    priceRange: "$9\u2013$14/sq ft",
    inStock: true,
    colors: ["grey"],
    featured: false,
    description: "Calypso Grigio is a stunning large-format polished slab with a warm grey marble aesthetic and flowing dark veins. This statement tile transforms any surface into a work of art, ideal for hotel lobbies, luxury residences, and spa environments.",
    images: [{ url: "/assets/images/tiles/48x72/calypso-grigio/calypso-grigio-r1-copy.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/calypso-grigio/calypso-grigio-r2-copy.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calypso-grigio/calypso-grigio-r3-copy.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calypso-grigio/calypso-grigio-r4-copy.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#c0bdb8",
      groutColor: "#a8a5a0",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 40 60 Q 130 180 192 288"],
    },
  },
  {
    id: "POR-026",
    collection: "rocagres",
    slug: "calypso-ice-48x72",
    name: "Calypso Ice",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["48x72"],
    priceRange: "$9\u2013$14/sq ft",
    inStock: true,
    colors: ["white"],
    featured: true,
    description: "Calypso Ice dazzles with its pure white background and barely-there silver veining, delivering crystalline clarity in a large-format slab. The polished surface amplifies natural light, creating an atmosphere of cool, refreshing luxury.",
    images: [{ url: "/assets/images/tiles/48x72/calypso-ice/calypso-ice-r1-copy.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/calypso-ice/calypso-ice-r2-copy.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calypso-ice/calypso-ice-r3-copy.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/calypso-ice/calypso-ice-r4-copy.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/calypso-ice.mp4",
    patternConfig: {
      baseColor: "#f6f4f2",
      groutColor: "#e0dedc",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 30 80 Q 100 200 192 260"],
    },
  },
  {
    id: "POR-027",
    collection: "rocagres",
    slug: "endless-colbert-ice-48x72",
    name: "Endless Colbert Ice",
    category: "porcelain",
    finish: "High Gloss",
    sizes: ["48x72"],
    priceRange: "$10\u2013$16/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "Endless Colbert Ice features a pearlescent icy white tone with a refined matte finish in an expansive large format. This architectural porcelain creates flow and continuity across surfaces, ideal for minimalist and Scandinavian-inspired interiors.",
    images: [{ url: "/assets/images/tiles/48x72/endless-colbert-ice/endless-colbert-ice-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/endless-colbert-ice/endless-colbert-ice-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/endless-colbert-ice/endless-colbert-ice-r3.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/colbert-ice.mp4",
    patternConfig: {
      baseColor: "#f0f0ee",
      groutColor: "#e0e0de",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: [],
    },
  },
  {
    id: "POR-028",
    collection: "rocagres",
    slug: "endless-tessino-verde-48x72",
    name: "Endless Tessino Verde",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["48x72"],
    priceRange: "$10\u2013$16/sq ft",
    inStock: true,
    colors: ["green"],
    featured: false,
    description: "Endless Tessino Verde is a rare and captivating large-format porcelain with deep forest-green tones and natural stone movement. This premium slab makes a bold, nature-inspired statement in any luxury residential or commercial project.",
    images: [{ url: "/assets/images/tiles/48x72/endless-tessino-verde/endless-tessino-verde-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/endless-tessino-verde/endless-tessino-verde-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/endless-tessino-verde/endless-tessino-verde-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/endless-tessino-verde/endless-tessino-verde-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/endless-tessino-verde.mp4",
    patternConfig: {
      baseColor: "#3a5c48",
      groutColor: "#2a4c38",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: [],
    },
  },
  {
    id: "POR-029",
    collection: "rocagres",
    slug: "onyx-misty-48x72",
    name: "Onyx Misty",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["48x72"],
    priceRange: "$11\u2013$18/sq ft",
    inStock: false,
    colors: ["gold", "brown"],
    featured: false,
    description: "Onyx Misty captures the ethereal translucency of natural onyx with its warm honey-gold tones and dramatic swirling movement. This large-format slab is the ultimate luxury statement piece for walls, reception areas, and exclusive residential projects.",
    images: [{ url: "/assets/images/tiles/48x72/onyx-misty/onyx-misty-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/onyx-misty/onyx-misty-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/onyx-misty/onyx-misty-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/onyx-misty/onyx-misty-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/onyx-misty.mp4",
    patternConfig: {
      baseColor: "#d4a860",
      groutColor: "#c09850",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 60 0 Q 150 200 192 288", "M 0 100 Q 80 180 150 288"],
    },
  },
  {
    id: "POR-030",
    collection: "rocagres",
    slug: "patagonia-ocean-48x72",
    name: "Patagonia Ocean",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["48x72"],
    priceRange: "$10\u2013$16/sq ft",
    inStock: false,
    colors: ["blue", "grey"],
    featured: false,
    description: "Patagonia Ocean brings the dramatic natural beauty of Argentinian quartzite to large-format porcelain. Its oceanic blue-grey tones with white quartzite veining create a breathtaking slab that elevates any luxury design project.",
    images: [{ url: "/assets/images/tiles/48x72/patagonia-ocean/patagonia-ocean-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/patagonia-ocean/patagonia-ocean-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/patagonia-ocean/patagonia-ocean-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/patagonia-ocean/patagonia-ocean-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/patagonia-ocean.mp4",
    patternConfig: {
      baseColor: "#6a7a88",
      groutColor: "#5a6a78",
      groutWidth: 4,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 40 0 Q 120 150 192 288"],
    },
  },
  {
    id: "POR-031",
    collection: "rocagres",
    slug: "statuario-oracle-48x72",
    name: "Statuario Oracle",
    category: "porcelain",
    finish: "Glossy",
    sizes: ["48x72"],
    priceRange: "$11\u2013$18/sq ft",
    inStock: true,
    colors: ["white"],
    featured: false,
    description: "Statuario Oracle replicates the rarest Italian Statuario marble in breathtaking large-format slabs. Its luminous white background with bold charcoal veining creates striking architectural surfaces for the most prestigious projects.",
    images: [{ url: "/assets/images/tiles/48x72/statuario-oracle/statuario-oracle-r1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/48x72/statuario-oracle/statuario-oracle-r2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/statuario-oracle/statuario-oracle-r3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/48x72/statuario-oracle/statuario-oracle-r4.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/statuario-oracle.mp4",
    patternConfig: {
      baseColor: "#f4f2f0",
      groutColor: "#dcdad8",
      groutWidth: 3,
      layout: "grid",
      tileWidth: 192,
      tileHeight: 288,
      veins: ["M 30 20 Q 100 150 192 260", "M 80 0 Q 160 180 180 288", "M 10 120 Q 80 220 150 288"],
    },
  },

  // ============================================================
  // WOOD-LOOK PORCELAIN 8x48
  // ============================================================
  {
    id: "WOD-001",
    collection: "rocagres",
    slug: "scotwood-brown-8x48",
    name: "Scotwood Brown",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["brown"],
    featured: false,
    description: "Scotwood Brown is a richly detailed wood-look porcelain plank with warm chestnut-brown tones and authentic grain texture. This 8x48 format replicates the look of solid hardwood with all the durability and easy maintenance of porcelain.",
    images: [{ url: "/assets/images/tiles/8x48/scotwood-brown-dg/scotwood-brown-1-m-face.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/scotwood-brown-dg/scotwood-brown-2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-brown-dg/scotwood-brown-3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-brown-dg/scotwood-brown-4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-brown-dg/scotwood-brown-5.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#7a5830",
      groutColor: "#6a4820",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  },
  {
    id: "WOD-002",
    collection: "rocagres",
    slug: "scotwood-grey-8x48",
    name: "Scotwood Grey",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["grey"],
    featured: false,
    description: "Scotwood Grey captures the driftwood aesthetic with cool grey tones and weathered wood grain texture. This versatile wood-look plank suits contemporary coastal, industrial, and Scandinavian-inspired interiors.",
    images: [{ url: "/assets/images/tiles/8x48/scotwood-grey-dg/scotwood-grey-1-tif-m-face.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/scotwood-grey-dg/scotwood-grey-2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-grey-dg/scotwood-grey-3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-grey-dg/scotwood-grey-4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/scotwood-grey-dg/scotwood-grey-5.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#8a9090",
      groutColor: "#7a8080",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  },
  {
    id: "WOD-003",
    collection: "rocagres",
    slug: "tibet-wood-beige-8x48",
    name: "Tibet Wood Beige",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["beige", "brown"],
    featured: false,
    description: "Tibet Wood Beige features warm blonde tones with fine natural grain detail, evoking the warmth of exotic hardwood flooring. This wood-look porcelain is ideal for creating inviting, warm atmospheres in living spaces, bedrooms, and hospitality environments.",
    images: [{ url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f7.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f8.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f9.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/tibet-wood-beige-f10/tibet-wood-beige-f10.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#c8a870",
      groutColor: "#b89860",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  },
  {
    id: "WOD-004",
    collection: "rocagres",
    slug: "torino-beige-8x48",
    name: "Torino Beige",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["beige"],
    featured: false,
    description: "Torino Beige is an elegant wood-look porcelain plank with soft beige tones and subtle wood grain, inspired by refined Italian design. Its understated warmth makes it a timeless choice for both residential and commercial projects.",
    images: [{ url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-beige-f8/torino-beige-102-f7.jpg", alt: "", type: "gallery" }],
    videoUrl: null,
    patternConfig: {
      baseColor: "#d4c090",
      groutColor: "#c4b080",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  },
  {
    id: "WOD-005",
    collection: "rocagres",
    slug: "torino-brown-8x48",
    name: "Torino Brown",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$4\u2013$7/sq ft",
    inStock: true,
    colors: ["brown"],
    featured: false,
    description: "Torino Brown features deep walnut-brown tones with rich wood grain detail in the classic Italian plank format. This sophisticated wood-look porcelain brings warmth and luxury to floors in living rooms, dining areas, and commercial spaces.",
    images: [{ url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f1-tif-m-face.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f7.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/torino-brown-f8/torino-brown-105-f8.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/torino-brown.mp4",
    patternConfig: {
      baseColor: "#6a4028",
      groutColor: "#5a3018",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  },
  {
    id: "WOD-006",
    collection: "rocagres",
    slug: "venish-wood-euro-8x48",
    name: "Venish Wood Euro",
    category: "woodLook",
    finish: "Matte",
    sizes: ["8x48"],
    priceRange: "$5\u2013$8/sq ft",
    inStock: true,
    colors: ["brown", "beige"],
    featured: false,
    description: "Venish Wood Euro is a premium wood-look porcelain plank capturing the elegance of European oak with fine grain texture and warm natural tones. This versatile plank pairs beautifully with both traditional and contemporary interiors.",
    images: [{ url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-1.jpg", alt: "", type: "primary" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-2.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-3.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-4.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-5.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-6.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-7.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-8.jpg", alt: "", type: "gallery" }, { url: "/assets/images/tiles/8x48/venish-wood-euro-dg/venish-wood-euro-9.jpg", alt: "", type: "gallery" }],
    videoUrl: "/assets/videos/venish-wood-euro.mp4",
    patternConfig: {
      baseColor: "#b89060",
      groutColor: "#a88050",
      groutWidth: 3,
      layout: "offset",
      tileWidth: 40,
      tileHeight: 192,
      veins: [],
    },
  }
];
